import React from "react";
import { PRESS_LOGOS } from "../../data/km";

export default function AsSeenIn() {
  const loop = [...PRESS_LOGOS, ...PRESS_LOGOS];
  return (
    <section className="py-14 sm:py-24 md:py-28 lg:py-32 bg-white overflow-hidden" data-testid="km-as-seen-in">
      <div className="text-center px-6 mb-8 sm:mb-14 lg:mb-16 reveal">
        <p className="km-eyebrow text-[11px] lg:text-[12.5px] mb-4 sm:mb-6 text-[#2C4A3B]">Premium Publications</p>
        <h2 className="km-serif text-[40px] sm:text-5xl lg:text-[64px] lg:leading-[1.08] text-[#141414]">As Seen <em>In</em></h2>
        <span className="block w-14 h-px bg-[#141414] mx-auto mt-6 sm:mt-8" />
      </div>
      <div className="group/press relative" data-testid="press-carousel">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 sm:w-32 z-10 bg-gradient-to-r from-white to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 sm:w-32 z-10 bg-gradient-to-l from-white to-transparent" />
        <div className="flex w-max items-center animate-marquee group-hover/press:[animation-play-state:paused]">
          {loop.map((l, i) => (
            <div key={i} className="flex items-center shrink-0" data-testid={`press-logo-${i}`}>
              <img src={l.src} alt={l.name} loading="lazy"
                className="h-8 sm:h-10 lg:h-12 w-auto max-w-[260px] sm:max-w-[320px] object-contain grayscale opacity-80 hover:opacity-100 transition-opacity duration-300 mx-8 sm:mx-12 lg:mx-14" />
              <span className="h-10 w-px bg-black/15" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
